import React, { Component } from "react";
import styled from "styled-components";

import Sidebar from "./components/Sidebar";
import MainContent from "./components/MainContent";

export class DashboardContainer extends Component {
  render() {
    return (
      <div>
        <Container>
          <Sidebar />
          <MainContent />
        </Container>
      </div>
    );
  }
}

const Container = styled.div`
  display: flex;
  background: linear-gradient(to bottom right, white 0%, #e6e4ff 70%);
  @media screen and (min-width: 320px) and (max-width: 768px) {
    flex-direction: column;
  }
`;




export default DashboardContainer;
